// Small formatting/number helpers, ported verbatim from the original app.
export function n1(x) { return Math.round(x * 10) / 10; }
export function n0(x) { return Math.round(x); }
export function uid() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 6); }
export function escHtml(s) {
  return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
